// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MainLayout from './components/layout/MainLayout';
import VendorLogin from './components/vendor/VendorLogin';
import VendorRegistration from './components/vendor/VendorRegistration';
import VendorOnboarding from './components/vendor/VendorOnboarding';
import VendorFastFood from './components/dashboard/FastFoodDashboard';
import HowItWorksPage from './components/pages/howitworks';
import { AuthProvider } from './auth/AuthContext';

// Create custom theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#0066CC',
      light: '#4B9FFF',
      dark: '#004C99',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#19857b',
      light: '#4FB3A9',
      dark: '#105852',
    },
    background: {
      default: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 500 },
    h6: { fontWeight: 500 },
    button: { fontWeight: 500, textTransform: 'none' },
  },
  shape: { borderRadius: 8 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 20px',
        },
        containedPrimary: {
          boxShadow: '0 4px 10px rgba(0, 102, 204, 0.25)',
          '&:hover': {
            boxShadow: '0 6px 12px rgba(0, 102, 204, 0.35)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 12,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <MainLayout>
            <Routes>
              <Route path="/" element={<Navigate to="/vendor/register" />} />
              {/* Vendor routes */}
              <Route path="/vendor/login" element={<VendorLogin />} />
              <Route path="/vendor/register" element={<VendorRegistration />} />
              <Route path="/vendor/onboarding" element={<VendorOnboarding />} />
              {/* Dashboard route: NO GlobalAlertProvider here */}
              <Route path="/vendor/dashboard" element={<VendorFastFood />} />
              {/* Catch-all for undefined routes */}
              <Route path="*" element={<Navigate to="/vendor/register" />} />
                <Route path="/how-it-works" element={<HowItWorksPage />} />
            </Routes>
          </MainLayout>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
